import PropTypes from 'prop-types'
import React from 'react'
import { PageHelmet } from 'Blocks'

const NotFound = ({
  title = 'Article Not Found',
  description = 'The article you are looking for does not exist anymore or the URL is wrong.',
  className = '',
  staticContext
}) => {
  if (staticContext) {
    staticContext.notFound = true
  }

  const pageName = 'articleNotFound'

  return (
    <div className={`main-container article-page ${className}`}>
      <PageHelmet pageName={pageName} description={description} />
      <h2>{title}</h2>
      <p>{description}</p>
    </div>
  )
}

NotFound.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string,
  staticContext: PropTypes.shape({
    notFound: PropTypes.any
  }),
  title: PropTypes.string
}

NotFound.displayName = 'NotFound'

export default NotFound
